import { IconType } from 'react-icons';
import {
  FiSmartphone,
  FiUsers,
  FiMessageSquare,
  FiLayers,
  FiActivity,
} from 'react-icons/fi';
import { MdScience } from 'react-icons/md';
import { TableCountsResponse } from '../../../api/types';
import {
  getDailyChange,
  getMonthlyChange,
  getWeeklyChange,
  getTotalCount,
} from './versionChartUtils';

/** Sabit kimlikler — sıra localStorage’da bu id’lere göre tutulur */
export const STAT_CARD_IDS = [
  'app_session',
  'game_session',
  'chat_session',
  'test_session',
  'users',
  'advertisements',
] as const;

export type StatCardId = (typeof STAT_CARD_IDS)[number];

export interface PageStatCard {
  id: StatCardId;
  label: string;
  value: string;
  change: string;
  weeklyChange: string;
  dailyChange: string;
  color: string;
  icon: IconType;
  link: string;
  totalToday?: string;
}

export function orderPageCardsByIds(
  cards: PageStatCard[],
  order: string[]
): PageStatCard[] {
  const byId = new Map(cards.map(c => [c.id, c]));
  const seen = new Set<string>();
  const result: PageStatCard[] = [];
  for (const id of order) {
    const card = byId.get(id as StatCardId);
    if (card) {
      result.push(card);
      seen.add(id);
    }
  }
  for (const c of cards) {
    if (!seen.has(c.id)) result.push(c);
  }
  return result;
}

export function buildPageCards(tableCounts: TableCountsResponse | null): PageStatCard[] {
  return [
    {
      id: 'app_session',
      label: 'Uygulama Oturumları',
      value: getTotalCount(tableCounts, 'app_session').toLocaleString('tr-TR'),
      change: getMonthlyChange(tableCounts, 'app_session'),
      weeklyChange: getWeeklyChange(tableCounts, 'app_session'),
      dailyChange: getDailyChange(tableCounts, 'app_session'),
      color: 'blue',
      icon: FiSmartphone as IconType,
      link: '/app-sessions',
    },
    {
      id: 'game_session',
      label: 'Oyun Oturumları',
      value: getTotalCount(tableCounts, 'game_session').toLocaleString('tr-TR'),
      change: getMonthlyChange(tableCounts, 'game_session'),
      weeklyChange: getWeeklyChange(tableCounts, 'game_session'),
      dailyChange: getDailyChange(tableCounts, 'game_session'),
      color: 'green',
      icon: FiActivity as IconType,
      link: '/game-sessions',
    },
    {
      id: 'chat_session',
      label: 'Sohbet Oturumları',
      value: getTotalCount(tableCounts, 'chat_session').toLocaleString('tr-TR'),
      change: getMonthlyChange(tableCounts, 'chat_session'),
      weeklyChange: getWeeklyChange(tableCounts, 'chat_session'),
      dailyChange: getDailyChange(tableCounts, 'chat_session'),
      color: 'indigo',
      icon: FiMessageSquare as IconType,
      link: '/chat-threads',
    },
    {
      id: 'test_session',
      label: 'Test Oturumları',
      value: getTotalCount(tableCounts, 'test_session').toLocaleString('tr-TR'),
      change: getMonthlyChange(tableCounts, 'test_session'),
      weeklyChange: getWeeklyChange(tableCounts, 'test_session'),
      dailyChange: getDailyChange(tableCounts, 'test_session'),
      color: 'orange',
      icon: MdScience as IconType,
      link: '/test-sessions',
    },
    {
      id: 'users',
      label: 'Kullanıcılar',
      value: getTotalCount(tableCounts, 'users').toLocaleString('tr-TR'),
      change: getMonthlyChange(tableCounts, 'users'),
      weeklyChange: getWeeklyChange(tableCounts, 'users'),
      dailyChange: getDailyChange(tableCounts, 'users'),
      color: 'teal',
      icon: FiUsers as IconType,
      link: '/users',
    },
    {
      id: 'advertisements',
      label: 'Reklamlar',
      value: getTotalCount(tableCounts, 'advertisements').toLocaleString('tr-TR'),
      change: getMonthlyChange(tableCounts, 'advertisements'),
      weeklyChange: getWeeklyChange(tableCounts, 'advertisements'),
      dailyChange: getDailyChange(tableCounts, 'advertisements'),
      color: 'purple',
      icon: FiLayers as IconType,
      link: '#',
    },
  ];
}
